<template>
  <!-- 法律聚焦 -->
  <div class="special">
    <section class="specialbanner">
      <img src="../../assets/special/special_banner_sample.png" alt="" />
    </section>
    <spejjzt />
    <speflly />



  </div>
</template>

<script>
import spejjzt from './child/spejjzt'
import speflly from './child/speflly'
export default {
    components:{
        spejjzt,
        speflly
    }
};
</script>

<style lang="scss" scoped>
.special {
  background-color: #fff;
  .specialbanner {
    max-width: 1920px;
    width: 100%;
    height: 520px;
    overflow: hidden;
    margin: 0 auto;
    img {
      width: 1920px;
    }
  }
}
</style>